export class Path {
    constructor(segments = []) {
        Object.defineProperty(this, "segments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.segments = [...segments].filter((segment) => !!segment);
    }
    static from(input = []) {
        const segments = getPathSegments(input);
        return new Path(segments);
    }
    toString() {
        const path = this.segments.join('/');
        if (path === '')
            return '/';
        return `/${path}/`;
    }
    prepend(other) {
        const { segments } = Path.from(other);
        return Path.from([...segments, ...this.segments]);
    }
    append(other) {
        const { segments } = Path.from(other);
        return Path.from([...this.segments, ...segments]);
    }
    removePrefix(other) {
        if (!this.startsWith(other))
            return this;
        const { segments } = Path.from(other);
        return new Path(this.segments.slice(segments.length));
    }
    startsWith(other) {
        return this.compareAsString(other, (a, b) => a.startsWith(b));
    }
    endsWith(other) {
        return this.compareAsString(other, (a, b) => a.endsWith(b));
    }
    equals(other) {
        return this.compareAsString(other, (a, b) => a === b);
    }
    compareAsString(other, fn) {
        const aString = this.toString();
        const bString = Path.from(other).toString();
        return fn(aString, bString);
    }
}
function getPathSegments(input) {
    if (input instanceof Path)
        return [...input.segments];
    if (Array.isArray(input))
        return input.flatMap(parsePathString);
    return parsePathString(input);
}
function parsePathString(input) {
    return input.split('/');
}
//# sourceMappingURL=Path.js.map